import App from './App'; // eslint-disable-line

export default App;
